import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.background_white};

  @media (max-width: 900px) {
    flex-direction: column;
  }

  @media (max-width: 450px) {
    gap: 0.5rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3rem;
  width: 80%;
  gap: 1rem;
  padding-right: 1rem;

  @media (max-width: 1050px) {
    gap: 0.5rem;
  }

  @media (max-width: 900px) {
    width: auto;
    margin-top: 0;
    padding: 1rem 1.5rem;
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  h1 {
    margin: 0;
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 1.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  .checkbox {
    color: ${({ theme }) => theme.colors.tertiary_500};
    width: 15%;
  }

  label {
    cursor: pointer;
    align-items: center;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 300;
    font-size: 1.15rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button {
    display: flex;
    align-items: center;
    width: 40%;
    color: ${({ theme }) => theme.colors.tertiary_500};
    border: none;
    background: none;
    padding: 0;
    font-size: 1rem;

    :hover {
      cursor: pointer;
    }
  }

  .profileName {
    display: block;
    background-color: ${({ theme }) => theme.colors.gray_250};
    border-radius: 1rem;
    padding-left: 0.5rem;
    text-align: start;
    width: 70%;
    color: ${({ theme }) => theme.colors.text_gray};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .profileNameSelected {
    display: block;
    background-color: ${({ theme }) => theme.colors.gray_250};
    border-radius: 1rem;
    padding-left: 0.5rem;
    text-align: start;
    font-weight: 700;
    width: 70%;
    color: ${({ theme }) => theme.colors.primary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .menuProfiles {
    display: flex;
    flex-direction: column;

    .containerTypeProfile {
      display: flex;
      gap: 1rem;
      align-items: center;
      justify-content: center;

      .title-financial {
        display: flex;
        gap: 0.5rem;
        align-items: center;

        svg {
          height: 1.1rem;
        }
      }
    }
    .contentButtons {
      display: flex;
      gap: 1rem;
      align-items: center;
      justify-content: space-between;
      .MuiIconButton-root {
        display: flex;
        width: 2.5rem;
        height: 2.5rem;
        align-items: center;
        justify-content: center;
      }
      .MuiInputBase-root-MuiInput-root:after {
        border-bottom: 2px solid red;
      }
    }
    .containerProfile {
      margin: 1rem 0;
      display: flex;
      flex-direction: column;
      gap: 1rem;

      h1 {
        margin: 0;
        color: ${({ theme }) => theme.colors.secondary};
        font-size: 1rem;
        text-decoration: underline;
      }

      .contentProfile {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        padding: 0.5rem;
        margin: 0 1rem;
        max-height: 50rem;
        overflow-y: auto;

        .profileItem {
          display: flex;
          min-height: 2rem;
          width: 100%;
          max-width: 25rem;
          justify-content: space-between;
          background-color: ${({ theme }) => theme.colors.gray_250};
          border-radius: 1rem;

          .delete {
            min-width: 0.1rem !important;
            width: 15% !important;
            svg {
              height: 1.1rem;
              fill: ${({ theme }) => theme.colors.error};
            }
          }
          /* .selected { 
            background-color: ${({ theme }) => theme.colors.primary};
            width: 1.5rem;
            height: 3rem;
            position: absolute;
            top: -17px;
            left: -12px;
            transform: rotate(43deg);
          } */
        }

        .buttonNewProfile button {
          width: auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }

  .configurationProfile {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    width: 100%;

    .nameProfile {
      display: flex;
      align-items: center;
      max-width: 30rem;
      h1 {
        display: block;
        font-size: 1.5rem;
        color: ${({ theme }) => theme.colors.secondary};
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .container-Approval-Value {
      margin-top: 1.1rem;
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;
      color: ${({ theme }) => theme.colors.secondary};

      h3 {
        font-size: 16px;
        font-weight: 300;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .dropDownApprovalValue {
        width: 45%;
        min-width: 13rem;

        .select-style {
          height: 1rem;
          padding: 0;
          font-size: 1rem;
        }

        .MuiOutlinedInput-notchedOutline {
          border: none;
          border-bottom: 1px ${({ theme }) => theme.colors.text} solid;
          border-radius: unset;
        }
      }
    }

    .textProfile {
      padding: 1.5rem 0 0 0;
      color: ${({ theme }) => theme.colors.text_gray};
      font-size: 1.2rem;
    }

    .contentAccordions {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .accordionTitle {
      padding: 0;
      border-bottom: 1px ${({ theme }) => theme.colors.primary} solid;

      p {
        font-size: 1.4rem;
        color: ${({ theme }) => theme.colors.secondary};
        font-weight: bold;
      }
    }

    .optionalIcons {
      border-bottom: 1px ${({ theme }) => theme.colors.primary} solid;
    }

    .containerApproval {
      display: flex;
      align-items: center;
      gap: 2rem;
      margin-top: 1rem;

      h1 {
        font-size: 1.2rem;
        font-weight: 300;
        color: ${({ theme }) => theme.colors.secondary};
      }

      .dropDown {
        width: 35%;

        .select-style {
          width: 100%;
          height: 1rem;
          padding: 0;
          font-size: 1rem;
          position: relative;
        }

        .MuiOutlinedInput-notchedOutline {
          border: none;
          border-bottom: 1px ${({ theme }) => theme.colors.text} solid;
          border-radius: unset;
        }
      }
    }

    .containerMapApprovers {
      display: flex;
      gap: 2rem;
      flex-wrap: wrap;
      margin-top: 1rem;

      .approvers {
        display: flex;
        align-items: center;
        width: 100%;
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.background_white};
        border-color: transparent;
        font-size: 1.1rem;
        padding: 0.4rem 0.4rem;
        border-radius: 0.5rem;
        justify-content: space-between;

        button {
          cursor: pointer;
          color: ${({ theme }) => theme.colors.primary};
          background: ${({ theme }) => theme.colors.yellow};
          border-color: transparent;
          border-radius: 100%;
          text-align: center;
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .profileEmpty {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .MuiInput-root {
    width: 75%;
  }

  .MuiInput-input {
    padding: 0;
    font-size: 1.2rem;
  }

  .containerAddButton {
    display: flex;
    width: 70%;
    justify-content: flex-end;
  }

  @media (max-width: 1050px) {
    padding-left: 0;
  }

  @media (max-width: 900px) {
    .contentProfile {
      margin: 0;
    }
  }

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;

    .menuProfiles {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .configurationProfile {
      width: 100%;
    }
  }

  @media (max-width: 600px) {
    .configurationProfile .containerApproval .dropDown {
      width: 35%;
    }
  }

  @media (max-width: 550px) {
    .configurationProfile .containerApproval {
      flex-direction: column;
      gap: 0.5rem;

      h1 {
        align-self: baseline;
      }

      .dropDown {
        width: 100%;
      }
    }

    .configurationProfile .container-Approval-Value .dropDownApprovalValue {
      width: 100%;
    }
  }

  @media (max-width: 450px) {
    .menuProfiles {
      display: flex;
    }
  }

  @media (max-width: 450px) {
    .configurationProfile .containerApproval {
      display: flex;
      flex-direction: column;
      align-items: start;
      gap: 1rem;
    }

    .configurationProfile .containerMapApprovers {
      gap: 1.2rem;
    }
  }

  @media (max-width: 300px) {
    .configurationProfile .containerApproval .dropDown {
      width: 100%;
    }
  }
`;

export const ContainerMap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 45rem;
  max-width: 100%;
  overflow-y: auto;

  .limitValueContainer {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .values {
      display: flex;
      align-items: center;
      margin-top: 1rem;

      .input {
        color: ${({ theme }) => theme.colors.tertiary};
      }

      span {
        padding: 0 1rem;
        font-size: 1.5rem;
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  @media (max-width: 350px) {
    .limitValueContainer .values span {
      padding: 0 0.2rem;
    }
  }
`;

export const ContentMap = styled.div`
  display: flex;
  align-items: center;
  width: 15rem;

  @media (max-width: 1190px) {
    width: 14rem;
  }

  @media (max-width: 1090px) {
    width: 13rem;
  }

  @media (max-width: 923px) {
    width: 12rem;
  }

  @media (max-width: 770px) {
    width: 15rem;
  }

  @media (max-width: 677px) {
    width: 13rem;
  }

  @media (max-width: 595px) {
    width: 12rem;
  }

  @media (max-width: 552px) {
    width: 15rem;
  }

  @media (max-width: 470px) {
    width: 12rem;
  }

  @media (max-width: 355px) {
    width: 15rem;
  }
`;
